import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronRight, faXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import IconButton from '~/components/buttons/IconButton';
import { getAppConfig, ipc } from '~/services/application.service';
const Header = ({ breadcrumbs = [], children, helpLink = '', sticky = false, title, }) => {
    const navigate = useNavigate();
    const { environment } = getAppConfig();
    const { type } = environment;
    if (type === 'DEVELOPMENT') {
        breadcrumbs.unshift({
            title: 'Home',
            onClick: () => {
                navigate('/');
            },
        });
    }
    return (_jsxs("div", { className: `flex flex-col justify-between border-b border-solid border-slate-300 bg-white bg-opacity-95 p-6 shadow-sm ${sticky ? 'sticky top-0 z-[100]' : ''}`, children: [type !== 'DEVELOPMENT' && window.isElectron && (_jsxs("div", { className: "fixed right-5 top-5 flex gap-2", children: [helpLink && (_jsx(IconButton, { Icon: faCircleQuestion, containerStyle: "h-12 w-12", onClick: () => {
                            ipc('windowAction', {
                                action: 'phoenixOpenHelpDocs',
                                isSync: false,
                                params: {
                                    page: helpLink,
                                },
                            });
                        } })), _jsx(IconButton, { Icon: faXmark, containerStyle: "h-12 w-12", onClick: () => window.close() })] })), _jsxs("div", { children: [_jsx("div", { className: "flex", children: breadcrumbs.map((breadcrumb, index) => (_jsxs("div", { className: "inline-flex", children: [index !== 0 && (_jsx("div", { className: "mx-2 flex items-center justify-center", children: _jsx(FontAwesomeIcon, { className: "mx-auto text-slate-500", icon: faChevronRight, size: "sm" }) })), _jsx("button", { className: "hover:cursor-pointer", onClick: breadcrumb.onClick, children: _jsx("span", { className: "text-gray-400 hover:underline", children: breadcrumb.title }) })] }, index))) }), _jsx("div", { children: _jsx("h1", { className: "text-3xl font-bold text-slate-700", children: title }) })] }), children && _jsx("div", { className: "mt-7 flex gap-3", children: children })] }));
};
export default Header;
